import React, { useContext, useEffect } from "react";
import { default as OlVectorSource } from "ol/source/Vector";
import { VectorLayerSourceContext } from "../VectorLayer";
/**
 * Creates a Vector source with the provided features array or `Collection`.
 */
export default function VectorSource({ features, useSpatialIndex = true, }) {
    const { setSource } = useContext(VectorLayerSourceContext);
    useEffect(() => {
        const source = new OlVectorSource({
            features,
            useSpatialIndex,
        });
        setSource(source);
    }, [features, setSource, useSpatialIndex]);
    return React.createElement(React.Fragment, null);
}
